var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.668H18.1696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.667H18.1696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.66504H15.8348"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16402 11.3329C9.99297 11.3329 10.665 10.6609 10.665 9.83199C10.665 9.00305 9.99297 8.33105 9.16402 8.33105C8.33508 8.33105 7.66309 9.00305 7.66309 9.83199C7.66309 10.6609 8.33508 11.3329 9.16402 11.3329Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1659 14.3344C11.8159 12.9622 10.5801 12.002 9.16398 12.002C7.74787 12.002 6.51202 12.9622 6.16211 14.3344H12.1659Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5027 17.0034C17.5027 16.2666 16.9054 15.6692 16.1685 15.6692C15.4317 15.6692 14.8344 16.2666 14.8344 17.0034V17.337C14.8344 17.5212 14.685 17.6705 14.5008 17.6705H10.1648C9.98058 17.6705 9.83125 17.5212 9.83125 17.337V17.0034C9.83125 16.2666 9.23392 15.6692 8.49708 15.6692C7.76024 15.6692 7.16292 16.2666 7.16292 17.0034V17.337C7.16292 17.5212 7.01359 17.6705 6.82938 17.6705H5.49521C5.12679 17.6705 4.82812 17.3718 4.82812 17.0034V6.99716C4.82812 6.62874 5.12679 6.33008 5.49521 6.33008H19.504C19.8724 6.33008 20.171 6.62874 20.171 6.99716V17.0034C20.171 17.3718 19.8724 17.6705 19.504 17.6705H17.8363C17.652 17.6705 17.5027 17.5212 17.5027 17.337V17.0034Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.82cdfb75.svg";
export { ForwardRef as ReactComponent };